module.exports = __webpack_public_path__ + "img/loding.259eaf9d.svg";